











































import { Vue } from "../../constants/constants";
import { constants } from "http2";
import {
  BasketLoadersEnum,
  genericErrorsEnum
} from "../../models/basket.model";
import { staticContent } from "../../localisation/detect-lang";

export default Vue.component("bulk-remove-items", {
  data() {
    return {
      staticContent,
      hasError: false,
      basketLoader: BasketLoadersEnum
    };
  },
  computed: {
    bindConditionalClasses(){
     return this.$root.bindConditionalClasses;
    },
    basket(){
      return this.$store.state.basket;
    },
     groupBasket() {
      return this.$store.state.groupBasket;
    },
    unavailableItems(){
    this.$store.state.unavailableItems
    },
    areAllItemsUnavailable(){
       let flatBasketItemsNoErrors=[];
       this.groupBasket.data.users ? 
       this.groupBasket.data.users.forEach((user,i)=>{
       user.categories.forEach((cat,i)=>{
          cat.items.forEach((item,j)=>{
             if(!item.error){
              flatBasketItemsNoErrors.push(item.basketItemUUID) 
             }           
          })
          })
       }): this.basket.data.categories && this.basket.data.categories.forEach((cat,i)=>{
          cat.items.forEach((item,j)=>{
            if(!item.error){
              flatBasketItemsNoErrors.push(item.basketItemUUID)
            }
          })
          })

          return !(flatBasketItemsNoErrors && flatBasketItemsNoErrors.length>0)


    }
  },
  
  methods: {
    hideModal() {
      this.$root.modalToggler('bulk-remove', 'hide')
    },
    bulkRemove() {
      if (navigator.onLine) {
      if( this.areAllItemsUnavailable){
   this.$store
          .dispatch("REMOVE_ALL_ITEMS_FROM_BASKET")
          .then(() => {
            this.$root.modalToggler('bulk-remove', 'hide');
            this.$store.commit("updateBasketIsGroup",false);
            this.$root.groupSummaryInterval &&
              clearInterval(this.$root.groupSummaryInterval);
            this.$root.compactBasketInterval &&
              clearInterval(this.$root.compactBasketInterval);
          })
          .catch(() => {
            this.$root.handleGenericErrors(
              genericErrorsEnum.generic,
              "remove-all"
            );
          })
          .catch(() => {
            this.hasError = true;
          });
      }
      else{
        this.$store
          .dispatch(
            "REMOVE_BULK_FROM_BASKET",
            this.$store.state.unavailableItems
          )
          .then(() => {
      if(this.$store.state.groupBasket.data.users){
        this.$store.dispatch('GET_GROUP_BASKET_SUMMARY',this.groupBasket.uuid).then(()=>{
        this.$root.modalToggler('bulk-remove', 'hide');

              this.openCheckoutModal();        
        })
      }
      else{
        this.$store.dispatch('GET_USER_BASKET_SUMMARY').then(()=>{
        this.$root.modalToggler('bulk-remove', 'hide');
              this.openCheckoutModal();        
        })
      }
        })
          .catch(() => {
            this.handleGenericErrors(genericErrorsEnum.generic);
          });
      } 
      }
      else {
        this.handleGenericErrors(genericErrorsEnum.internet);
      }
    },
    openCheckoutModal() {
      if (
        this.$root.basketHasError &&
        this.$root.basketError.basketErrorMsg.showModal
      ) {
        this.$store.dispatch("GET_USER_BASKET_SUMMARY").then(() => {
          if (
            this.$root.basketHasError &&
            this.$root.basketError.basketErrorMsg.showModal
          ) {
            this.$root.basketErrors();
          } else this.openCheckoutModal();
        });
      } else {
        if (navigator.onLine) {
          this.$store
            .dispatch("GET_USER_BASKET")
            .then(() => {
                this.$root.pushAnalyticsEvent(
            this.$root.analyticsEvents.ordering.category,
            this.$root.analyticsEvents.ordering.events.proceedToCheckout,
             this.$root.analyticsEvents.ordering.labels.basketUUID(this.$store.state.basket.uuid)
          );
           window['gtag']('event', 'begin_checkout');
              this.$root.pushMixpanelEvent(
                this.$root.mixpanelEvents.mainCheckoutScreen.event,
                this.$root.mixpanelEvents.mainCheckoutScreen.properties(
                  this.$store.state.basket.ref.restaurant
                    ? this.$store.state.basket.ref.restaurant.name
                    : "N/A",
                  this.$store.state.basket.ref.address &&
                    this.$store.state.basket.ref.address.ref.areaUUID
                    ? this.$root.flatAreas[
                        this.$store.state.basket.ref.address.ref.areaUUID
                      ].name
                    : this.$store.state.basket.ref.zoneUUID &&
                        this.$root.flatAreas[
                          this.$root.flatZones[
                            this.$store.state.basket.ref.zoneUUID
                          ].areaUUID
                        ].name,
                        this.$store.state.basket.data.receipt.deliveryCharges.serviceFees !== 0,
                        this.$store.state.basket.data.receipt.deliveryCharges.serviceFees
                )
              );
              this.$store.state.basket.ref.address &&
              this.$store.state.basket.ref.address.uuid
                ? this.$store.commit("setCheckoutStep", 2)
                : this.checkoutGoToStep1();
            })
            .catch(() => {
              this.checkoutGoToStep1();
            });
          this.$store.commit("updateCheckoutVisibility", true);

          document.documentElement.clientWidth <= 1024 &&
            this.$store.commit("changeBasketVisibility", false);
          this.$root.modalToggler('checkout-modal', 'show')
        } else {
          this.$root.handleGenericErrors(genericErrorsEnum.internet);
           if (window['fcWidget'] && !window['fcWidget'].isInitialized()) {
          try {
            this.$root.initChat()
          } catch (error) {
            console.log(`Error while init FreshChat`, error)
          }
        }
        }
      }
    },
     checkoutGoToStep1() {
      this.$store.commit("setCheckoutStep", 1);
      this.$store.dispatch(`GET_USER_BASKET_ADDRESSES`);
    },
  }
});
